import React from 'react';
import { Moment } from "moment";
import { useDispatch } from "react-redux";
import { FreeBusyStatus } from '@features/whereabouts/services/WhereaboutOptions';
import { updateMovement } from '@features/whereabouts/store/editMovements.duck';
import { DATE_FORMAT } from '@shared/utils/DateUtils';
import { MovementImage } from "../../../atoms/MovementImage";
import { iconPackPath } from '@shared/utils/WhereaboutsHelper';
import { BodyRegular, BodyVerySmall } from "../../../atoms/fonts/Body";
import Colours from "../../../atoms/Colours";
import { DialogIdentifiers, openDialogWithPayload } from '@shared/store/dialog.duck';

export function OptionListActivityItem(props: Props) {
  const {activeDay, iconPack, activity, activeUserId} = props;
  const dispatch = useDispatch();

  const activitySelected = (e: any) => {
    e.stopPropagation();
    dispatch(openDialogWithPayload({
      payload: { onOptionPicked: onOptionPicked, whereabouts: activity },
      activeDialog: DialogIdentifiers.WhereaboutsOptionPickerDialog
    }))
  }

  const onOptionPicked = (e: Event, optionItemId?: number, freeText?: string) => {
    dispatch(updateMovement({
      selectedOption: activity,
      locationId: 0,
      activeDay: activeDay?.format(DATE_FORMAT),
      activeUserId,
      optionItemId: optionItemId,
      optionItemText: freeText,
    }));
  }

  return (<div className="activity" onClick={(e: any) => activitySelected(e)}>
    <MovementImage src={iconPackPath(iconPack, activity.image, FreeBusyStatus.FREE)} alt={activity.alt}/>
    <BodyRegular weight={600}>{activity.label}</BodyRegular>
    {props?.activity?.isPrivate && <BodyVerySmall colour={Colours.mildGrey} title={'This is only visible to you, line managers, and company admins.'}>Private</BodyVerySmall>}
  </div>)
}

interface Props {
  activeDay?: Moment;
  iconPack: any;
  activity: any;
  activeUserId?: string;
}
